import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth'
//import globalAxios from 'axios'

import routes from './routes/routes.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idToken: null,
    user: null
  },
  mutations: {
    storeUser (state, user) {
      state.user = user
    }

  },
  actions: {

    login ({commit, dispatch}, authData) {
      console.log(authData.username)
      commit('storeUser', authData.username)
      //this.$store.state.user=authData.username
    },
    /*
    login ({commit, dispatch}, authData) {
      axios.post('http://127.0.0.1:8000/api-token/', {
        username: authData.username,
        password: authData.password,
       // returnSecureToken: true
      })
        .then(res => {
          //console.log(res)
          //const now = new Date()
          //const expirationDate = new Date(now.getTime() + res.data.expiresIn * 1000)
          localStorage.setItem('token', res.data.access)
          //localStorage.setItem('retoken', res.data.refresh)
          //context.commit('updateStorage', { access: res.data.access, refresh: response.data.refresh })


          //localStorage.setItem('userId', res.data.localId)
          //localStorage.setItem('expirationDate', expirationDate)
          
          //dispatch('setLogoutTimer', res.data.expiresIn)
          if(res.data.access !== null){ routes.push({ path: '/dashboard' })}
        })
        .catch(error => console.log(error))
    },*/
    

    logout () {
     // localStorage.removeItem('expirationDate')
      localStorage.removeItem('token')
      localStorage.removeItem('retoken')
      localStorage.removeItem('username')
      localStorage.removeItem('page_name')
    //  localStorage.removeItem('userId')
      routes.replace('/signin')
    },
    fetchUser ({commit}) {

      const token = localStorage.getItem('token')
      const username = localStorage.getItem('username')

      axios.get('http://127.0.0.1:8000/user/'+ username, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          //console.log(response)
          commit('storeUser', response.data)
          // this.$store.state.APIData = response.data
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    isAuthenticated (state) {
      return state.user !== null
    }
  }
})
